import { render } from "./1Pekerjaan.vue?vue&type=template&id=64a9c967"
import script from "./1Pekerjaan.vue?vue&type=script&lang=js"
export * from "./1Pekerjaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__